import { StructureDemo } from "util/instance";
import { channelFullDemoData } from "./channeldemo.data";

export function AdminManageChannelFullDemo() {
    return (
        <StructureDemo
            structureKey={"admin"}
            instanceKey={"one"}
            screenKey={"manageChannels"}
            testState={{ modulePublic: channelFullDemoData.modulePublic, serverCall: channelFullDemoData.serverCall }}
            features={{ adminmanagechannels: true,channelbase:true }}
        />
    );
}